export const translations = {
  en: {
    app_name: "Sakhi Didi",
    tagline: "Your trusted didi for questions about growing up",
    hero_title: "Hi, I'm Sakhi Didi.",
    hero_sub: "Tap the microphone and talk to me. Ask me anything about your body, periods, staying safe, or your future.",
    chat_cta: "Talk to Sakhi Didi",
    education_hub: "Education Hub",
    career_hub: "Career Hub",
    home: "Home",
    back: "Back",
    language: "Language",
    education_desc: "Short, safe videos on periods, hygiene, safety and growing up.",
    career_desc: "Answer 15 fun questions and discover careers that fit you.",
    start_quiz: "Start the Quiz",
    next: "Next",
    submit: "See my Result",
    your_personality: "Your Personality",
    suggested_careers: "Careers you may love",
    retake: "Take the quiz again",
    type_message: "Type your question...",
    send: "Send",
    chat_intro: "Tap the microphone and ask me anything. I'm listening.",
    mic_optional_hint: "No microphone? No problem — type your question below and I'll answer.",
    mic_start_failed: "Couldn't start the microphone. You can type your question below instead.",
    watch_now: "Watch now",
    all: "All",
    menstruation: "Menstruation",
    safety: "Safety",
    wellbeing: "Well-being",
    footer: "A safe space for every girl.",
    install_app: "Install app",
    question_of: "Question",
    of: "of",
    tap_to_speak: "Tap to speak",
    listening: "Listening...",
    thinking: "Thinking...",
    speaking: "Sakhi Didi is speaking",
    tap_to_stop: "Tap to stop",
    or_type: "Or type here",
    voice_unsupported: "Voice chat needs Chrome, Edge or Safari. You can still type below.",
    say_again: "Say it again",
    sos: "SOS",
    sos_title: "Need help right now?",
    sos_sub: "You are not alone. Call any of these free helplines — anyone can call, any time.",
    sos_call: "Call now",
    sos_talk_adult: "Also talk to a teacher, parent or any adult you trust.",
    childline: "Childline (for children)",
    women_helpline: "Women Helpline",
    emergency: "Emergency",
    cyber_helpline: "Cyber Crime",
    // Panic SMS
    send_panic_sms: "Send silent SMS to",
    panic_sms_body: "I need help. This is an urgent message from the Sakhi Didi app.",
    trusted_adult_not_set: "No trusted adult set yet. Ask a teacher to open Settings.",
    // Admin / Settings
    settings: "Settings",
    admin_settings: "School Kiosk Settings",
    trusted_adult: "Trusted Adult",
    trusted_adult_name: "Name (e.g. School Counsellor)",
    trusted_adult_phone: "Phone number (with country code)",
    save: "Save",
    saved: "Saved",
    voice_settings: "Sakhi Didi Voice",
    voice_default: "Default (system)",
    preview_voice: "Preview voice",
    sakhi_photo: "Sakhi Didi Photo",
    upload_photo: "Upload photo",
    remove_photo: "Remove",
    photo_hint: "PNG or JPG. Best around 800×1000. Stored only on this kiosk.",
    reading_mode: "Reading mode (subtitles)",
    reading_mode_hint: "Show large scrolling captions when Sakhi Didi speaks.",
    auto_lang_hint: "Speak Hindi, English or a natural mix — Sakhi Didi will match your style.",
    // History
    history: "History",
    my_history: "My conversations",
    no_history: "You haven't chatted with Sakhi Didi yet. Tap the microphone to start.",
    clear_history: "Clear history",
    // Offline
    offline_banner: "You are offline. I'll answer from my stored knowledge.",
    offline_fallback: "I'm not sure about that right now, and I can't reach my helper. Please ask a teacher, or for urgent help call Childline 1098.",
    // Starter suggestion chips
    suggested_questions: "Not sure what to ask? Try one of these",
    q_period_pain: "Why do I feel period pain?",
    q_feel_sad: "Why do I feel sad?",
    q_what_is_period: "What is a period?",
    q_stay_safe: "How do I stay safe?",
    // Admin dashboard
    view_dashboard: "View Analytics",
    dashboard_title: "Kiosk Analytics",
    dashboard_sub: "Anonymised usage from this kiosk",
    metric_conversations: "Conversations",
    metric_messages: "Total messages",
    metric_user_msgs: "Questions asked",
    metric_quizzes: "Career quizzes",
    chart_daily: "Daily activity (last 14 days)",
    chart_lang: "Questions by language",
    chart_traits: "Career quiz — top traits",
    recent_questions: "Recent questions",
    no_data: "No data yet. Ask Sakhi Didi to get started.",
    // PIN gate
    pin_lock: "Admin only",
    pin_create_title: "Create an Admin PIN",
    pin_create_sub: "Set a 4-digit PIN for this school kiosk. Only teachers should know it.",
    pin_enter_title: "Enter Admin PIN",
    pin_enter_sub: "Only school staff can view Settings and Analytics.",
    pin_confirm: "Confirm PIN",
    pin_mismatch: "PINs do not match. Try again.",
    pin_wrong: "Wrong PIN. Try again.",
    pin_reset_hint: "Forgot the PIN?",
    pin_reset_btn: "Reset kiosk PIN & settings",
    pin_reset_confirm: "This will erase the PIN, trusted adult and photo on this device. Continue?",
    unlock: "Unlock",
    // Hero
    get_help_now: "Get help now",
    // Wake word / Pace / Emotion
    wake_word: "Wake word (say \"Sakhi Didi\")",
    wake_word_hint: "Girls can start the mic hands-free just by saying the wake phrase.",
    wake_word_active: "Say",
    wake_phrase_label: "Wake phrase",
    wake_phrase_placeholder: "e.g. Sakhi Didi, Anjali Didi, Priya Akka",
    barge_hint: "You can interrupt me anytime — just start speaking",
    speech_pace: "Speaking speed",
    pace_slow: "Slow (0.9×)",
    pace_normal: "Normal",
    pace_fast: "Fast (1.1×)",
  },
  hi: {
    app_name: "सखी दीदी",
    tagline: "बड़े होने से जुड़े हर सवाल की भरोसेमंद दीदी",
    hero_title: "नमस्ते, मैं सखी दीदी हूँ।",
    hero_sub: "अपने शरीर, माहवारी, सुरक्षा या भविष्य से जुड़ा कोई भी सवाल पूछो। कोई सवाल छोटा नहीं होता।",
    chat_cta: "सखी दीदी से बात करो",
    education_hub: "शिक्षा केंद्र",
    career_hub: "करियर केंद्र",
    home: "होम",
    back: "वापस",
    language: "भाषा",
    education_desc: "माहवारी, स्वच्छता, सुरक्षा पर छोटे-छोटे सुरक्षित वीडियो।",
    career_desc: "15 मज़ेदार सवालों के जवाब दो और अपने लिए सही करियर खोजो।",
    start_quiz: "क्विज़ शुरू करो",
    next: "आगे",
    submit: "मेरा परिणाम देखो",
    your_personality: "तुम्हारा व्यक्तित्व",
    suggested_careers: "करियर जो तुम्हें पसंद आ सकते हैं",
    retake: "फिर से क्विज़ लो",
    type_message: "अपना सवाल लिखो...",
    send: "भेजो",
    chat_intro: "माइक दबाओ और कुछ भी पूछो। दीदी सुन रही है।",
    mic_optional_hint: "माइक नहीं है? कोई बात नहीं — नीचे अपना सवाल टाइप करो, मैं जवाब दूँगी।",
    mic_start_failed: "माइक शुरू नहीं हो पाया। नीचे टाइप करके पूछ सकती हो।",
    watch_now: "अभी देखो",
    all: "सभी",
    menstruation: "माहवारी",
    safety: "सुरक्षा",
    wellbeing: "स्वास्थ्य",
    footer: "हर लड़की के लिए एक सुरक्षित जगह।",
    install_app: "ऐप इंस्टॉल करें",
    question_of: "प्रश्न",
    of: "में से",
    tap_to_speak: "बोलने के लिए दबाओ",
    listening: "सुन रही हूँ...",
    thinking: "सोच रही हूँ...",
    speaking: "सखी दीदी बोल रही है",
    tap_to_stop: "रोकने के लिए दबाओ",
    or_type: "या यहाँ लिखो",
    voice_unsupported: "आवाज़ के लिए Chrome, Edge या Safari इस्तेमाल करो। तुम नीचे लिखकर भी पूछ सकती हो।",
    say_again: "फिर से बोलो",
    sos: "मदद",
    sos_title: "अभी मदद चाहिए?",
    sos_sub: "तुम अकेली नहीं हो। इनमें से किसी भी मुफ्त हेल्पलाइन पर कभी भी कॉल कर सकती हो।",
    sos_call: "अभी कॉल करो",
    sos_talk_adult: "अपने शिक्षक, माता-पिता या किसी भरोसेमंद बड़े से भी बात करो।",
    childline: "चाइल्डलाइन (बच्चों के लिए)",
    women_helpline: "महिला हेल्पलाइन",
    emergency: "आपातकाल",
    cyber_helpline: "साइबर क्राइम",
    send_panic_sms: "गुप्त SMS भेजो",
    panic_sms_body: "मुझे मदद चाहिए। यह Sakhi Didi ऐप से तुरंत भेजा गया संदेश है।",
    trusted_adult_not_set: "अभी कोई भरोसेमंद बड़ा तय नहीं है। शिक्षक से सेटिंग खोलने को कहो।",
    settings: "सेटिंग",
    admin_settings: "स्कूल कियोस्क सेटिंग",
    trusted_adult: "भरोसेमंद बड़ा",
    trusted_adult_name: "नाम (जैसे स्कूल काउंसलर)",
    trusted_adult_phone: "फोन नंबर (देश कोड सहित)",
    save: "सेव करो",
    saved: "सेव हो गया",
    voice_settings: "सखी दीदी की आवाज़",
    voice_default: "डिफ़ॉल्ट",
    preview_voice: "आवाज़ सुनो",
    history: "इतिहास",
    my_history: "मेरी बातचीत",
    no_history: "अभी तक कोई बातचीत नहीं। माइक दबाओ और शुरू करो।",
    clear_history: "साफ़ करो",
    offline_banner: "तुम ऑफ़लाइन हो। मैं अपने संग्रह से जवाब दूँगी।",
    offline_fallback: "मुझे इस समय ठीक से पता नहीं है और मेरा सहायक भी उपलब्ध नहीं है। किसी शिक्षक से पूछो, या तुरंत मदद के लिए 1098 पर कॉल करो।",
    suggested_questions: "क्या पूछना है सोच नहीं पा रही? इनमें से एक चुनो",
    q_period_pain: "मुझे पीरियड्स में दर्द क्यों होता है?",
    q_feel_sad: "मुझे उदासी क्यों होती है?",
    q_what_is_period: "पीरियड क्या होता है?",
    q_stay_safe: "मैं खुद को कैसे सुरक्षित रखूँ?",
    view_dashboard: "एनालिटिक्स देखो",
    dashboard_title: "कियोस्क एनालिटिक्स",
    dashboard_sub: "इस कियोस्क से गुप्त उपयोग डेटा",
    metric_conversations: "बातचीत",
    metric_messages: "कुल संदेश",
    metric_user_msgs: "प्रश्न पूछे गए",
    metric_quizzes: "करियर क्विज़",
    chart_daily: "दैनिक गतिविधि (पिछले 14 दिन)",
    chart_lang: "भाषा के अनुसार प्रश्न",
    chart_traits: "करियर क्विज़ — शीर्ष लक्षण",
    recent_questions: "हाल के प्रश्न",
    no_data: "अभी कोई डेटा नहीं। सखी दीदी से पूछकर शुरू करो।",
    pin_lock: "केवल एडमिन",
    pin_create_title: "एडमिन PIN बनाओ",
    pin_create_sub: "इस स्कूल कियोस्क के लिए 4-अंकों का PIN सेट करो। केवल शिक्षक को पता होना चाहिए।",
    pin_enter_title: "एडमिन PIN डालो",
    pin_enter_sub: "केवल स्कूल के शिक्षक ही सेटिंग और एनालिटिक्स देख सकते हैं।",
    pin_confirm: "PIN फिर से डालो",
    pin_mismatch: "PIN मेल नहीं खा रहा। फिर से कोशिश करो।",
    pin_wrong: "गलत PIN। फिर से कोशिश करो।",
    pin_reset_hint: "PIN भूल गए?",
    pin_reset_btn: "कियोस्क PIN और सेटिंग रीसेट करो",
    pin_reset_confirm: "इससे PIN, भरोसेमंद बड़ा और फोटो मिट जाएगा। जारी रखें?",
    unlock: "खोलो",
    get_help_now: "अभी मदद चाहिए",
    wake_word: "जगाओ शब्द (कहो \"सखी दीदी\")",
    wake_word_hint: "लड़कियाँ बिना हाथ लगाए बस अपना जगाओ शब्द बोलकर माइक शुरू कर सकती हैं।",
    wake_word_active: "बोलो",
    wake_phrase_label: "जगाओ शब्द",
    wake_phrase_placeholder: "उदा. सखी दीदी, अंजलि दीदी",
    barge_hint: "जब चाहो बीच में बोल सकती हो — बस बोलना शुरू करो",
    speech_pace: "बोलने की गति",
    pace_slow: "धीमा (0.9×)",
    pace_normal: "सामान्य",
    pace_fast: "तेज़ (1.1×)",
  },
  mr: {
    app_name: "सखी दीदी",
    tagline: "मोठ्या होण्याच्या प्रत्येक प्रश्नाची विश्वासू दीदी",
    hero_title: "नमस्कार, मी सखी दीदी.",
    hero_sub: "तुमच्या शरीराबद्दल, मासिक पाळीबद्दल, सुरक्षिततेबद्दल किंवा भविष्याबद्दल काहीही विचारा.",
    chat_cta: "सखी दीदीशी बोला",
    education_hub: "शिक्षण केंद्र",
    career_hub: "करिअर केंद्र",
    home: "मुख्यपृष्ठ",
    back: "मागे",
    language: "भाषा",
    education_desc: "मासिक पाळी, स्वच्छता आणि सुरक्षिततेवर लहान सुरक्षित व्हिडिओ.",
    career_desc: "१५ प्रश्नांची उत्तरे द्या आणि तुमच्यासाठी योग्य करिअर शोधा.",
    start_quiz: "क्विझ सुरू करा",
    next: "पुढे",
    submit: "माझा निकाल पहा",
    your_personality: "तुमचे व्यक्तिमत्त्व",
    suggested_careers: "तुम्हाला आवडतील अशी करिअर",
    retake: "पुन्हा क्विझ द्या",
    type_message: "तुमचा प्रश्न लिहा...",
    send: "पाठवा",
    chat_intro: "माइक दाबा आणि काहीही विचारा. दीदी ऐकत आहे.",
    mic_optional_hint: "माइक नाही? काही हरकत नाही — खाली तुमचा प्रश्न टाइप करा, मी उत्तर देईन.",
    mic_start_failed: "माइक सुरू करता आला नाही. खाली टाइप करून विचारू शकता.",
    watch_now: "आता पहा",
    all: "सर्व",
    menstruation: "मासिक पाळी",
    safety: "सुरक्षा",
    wellbeing: "स्वास्थ्य",
    footer: "प्रत्येक मुलीसाठी सुरक्षित जागा.",
    install_app: "अ‍ॅप इन्स्टॉल करा",
    question_of: "प्रश्न",
    of: "पैकी",
    tap_to_speak: "बोलण्यासाठी दाबा",
    listening: "ऐकत आहे...",
    thinking: "विचार करत आहे...",
    speaking: "सखी दीदी बोलत आहे",
    tap_to_stop: "थांबवण्यासाठी दाबा",
    or_type: "किंवा येथे लिहा",
    voice_unsupported: "आवाजासाठी Chrome, Edge किंवा Safari वापरा. खाली लिहून विचारू शकता.",
    say_again: "पुन्हा सांग",
    sos: "मदत",
    sos_title: "आत्ता मदत हवी आहे?",
    sos_sub: "तू एकटी नाहीस. यापैकी कोणत्याही मोफत हेल्पलाइनला कधीही फोन कर.",
    sos_call: "आत्ता फोन करा",
    sos_talk_adult: "शिक्षक, पालक किंवा विश्वासू व्यक्तीशीही बोल.",
    childline: "चाइल्डलाइन (मुलांसाठी)",
    women_helpline: "महिला हेल्पलाइन",
    emergency: "आपत्कालीन",
    cyber_helpline: "सायबर क्राइम",
    send_panic_sms: "गुप्त SMS पाठवा",
    panic_sms_body: "मला मदत हवी आहे. हा Sakhi Didi अ‍ॅपचा तातडीचा संदेश आहे.",
    trusted_adult_not_set: "अद्याप विश्वासू व्यक्ती सेट केलेली नाही. शिक्षकांना सेटिंग्ज उघडायला सांग.",
    settings: "सेटिंग्ज",
    admin_settings: "शाळेच्या कियोस्क सेटिंग्ज",
    trusted_adult: "विश्वासू व्यक्ती",
    trusted_adult_name: "नाव (उदा. शाळेचे समुपदेशक)",
    trusted_adult_phone: "फोन नंबर (देश कोडसह)",
    save: "सेव्ह",
    saved: "सेव्ह झाले",
    voice_settings: "सखी दीदीचा आवाज",
    voice_default: "डिफॉल्ट",
    preview_voice: "आवाज ऐका",
    history: "इतिहास",
    my_history: "माझे संवाद",
    no_history: "अद्याप सखी दीदीशी बोलले नाहीस. माइक दाब आणि सुरू कर.",
    clear_history: "साफ कर",
    offline_banner: "तू ऑफलाइन आहेस. मी माझ्या साठवलेल्या ज्ञानातून उत्तर देईन.",
    offline_fallback: "आत्ता मला नक्की माहीत नाही. शिक्षिकेला विचार, किंवा तातडीच्या मदतीसाठी 1098 वर कॉल कर.",
    suggested_questions: "काय विचारायचे कळत नाही? यापैकी एक निवड",
    q_period_pain: "मला मासिक पाळीत दुखणे का होते?",
    q_feel_sad: "मला उदासी का येते?",
    q_what_is_period: "मासिक पाळी म्हणजे काय?",
    q_stay_safe: "मी स्वतःला सुरक्षित कसे ठेवू?",
    view_dashboard: "अ‍ॅनालिटिक्स पहा",
    dashboard_title: "कियोस्क अ‍ॅनालिटिक्स",
    dashboard_sub: "या कियोस्कमधून अनामिक वापर डेटा",
    metric_conversations: "संवाद",
    metric_messages: "एकूण संदेश",
    metric_user_msgs: "विचारलेले प्रश्न",
    metric_quizzes: "करिअर क्विझ",
    chart_daily: "दैनिक क्रियाकलाप (मागील 14 दिवस)",
    chart_lang: "भाषेनुसार प्रश्न",
    chart_traits: "करिअर क्विझ — शीर्ष गुण",
    recent_questions: "अलीकडील प्रश्न",
    no_data: "अद्याप कोणताही डेटा नाही. सखी दीदीशी बोलून सुरुवात कर.",
    pin_lock: "फक्त प्रशासक",
    pin_create_title: "प्रशासक PIN तयार करा",
    pin_create_sub: "या शाळेच्या कियोस्कसाठी 4-अंकी PIN सेट करा. फक्त शिक्षकांना माहिती असावी.",
    pin_enter_title: "प्रशासक PIN टाका",
    pin_enter_sub: "फक्त शाळेचे कर्मचारी सेटिंग्ज व अ‍ॅनालिटिक्स पाहू शकतात.",
    pin_confirm: "PIN पुष्टी करा",
    pin_mismatch: "PIN जुळत नाही. पुन्हा प्रयत्न करा.",
    pin_wrong: "चुकीचा PIN. पुन्हा प्रयत्न करा.",
    pin_reset_hint: "PIN विसरलात?",
    pin_reset_btn: "कियोस्क PIN आणि सेटिंग्ज रीसेट करा",
    pin_reset_confirm: "यामुळे PIN, विश्वासू व्यक्ती व फोटो मिटेल. सुरू ठेवायचे?",
    unlock: "उघडा",
    get_help_now: "आत्ता मदत हवी",
    wake_word: "वेक शब्द (\"सखी दीदी\" म्हणा)",
    wake_word_hint: "मुली हातांचा वापर न करता फक्त वेक शब्द बोलून माइक सुरू करू शकतात.",
    wake_word_active: "म्हणा",
    wake_phrase_label: "वेक शब्द",
    wake_phrase_placeholder: "उदा. सखी दीदी, अंजली दीदी",
    barge_hint: "कधीही मध्येच बोलू शकतेस — फक्त बोलायला सुरुवात कर",
    speech_pace: "बोलण्याचा वेग",
    pace_slow: "हळू (0.9×)",
    pace_normal: "सामान्य",
    pace_fast: "जलद (1.1×)",
  },
  te: {
    app_name: "సఖి దీది",
    tagline: "పెరుగుతున్న అన్ని ప్రశ్నలకు నమ్మకమైన దీది",
    hero_title: "నమస్తే, నేను సఖి దీది.",
    hero_sub: "మైక్ నొక్కి నాతో మాట్లాడు. నీ శరీరం, పీరియడ్స్, భద్రత లేదా భవిష్యత్తు గురించి ఏదైనా అడుగు.",
    chat_cta: "సఖి దీదితో మాట్లాడు",
    education_hub: "విద్యా కేంద్రం",
    career_hub: "కెరీర్ కేంద్రం",
    home: "హోమ్",
    back: "వెనుకకు",
    language: "భాష",
    education_desc: "పీరియడ్స్, పరిశుభ్రత, భద్రత గురించి చిన్న సురక్షిత వీడియోలు.",
    career_desc: "15 సరదా ప్రశ్నలకు సమాధానం ఇచ్చి నీకు తగిన కెరీర్ కనుగొను.",
    start_quiz: "క్విజ్ ప్రారంభించు",
    next: "తర్వాత",
    submit: "నా ఫలితం చూపించు",
    your_personality: "నీ వ్యక్తిత్వం",
    suggested_careers: "నీకు నచ్చే కెరీర్లు",
    retake: "మళ్ళీ క్విజ్ తీసుకో",
    type_message: "నీ ప్రశ్న రాయి...",
    send: "పంపు",
    chat_intro: "మైక్ నొక్కి ఏదైనా అడుగు. దీది వింటోంది.",
    mic_optional_hint: "మైక్ లేదా? పర్వాలేదు — నీ ప్రశ్నను కింద టైప్ చేయి, నేను జవాబిస్తా.",
    mic_start_failed: "మైక్ ప్రారంభించలేకపోయాం. కింద టైప్ చేసి అడగవచ్చు.",
    watch_now: "ఇప్పుడు చూడు",
    all: "అన్నీ",
    menstruation: "పీరియడ్స్",
    safety: "భద్రత",
    wellbeing: "ఆరోగ్యం",
    footer: "ప్రతి అమ్మాయికి సురక్షిత స్థలం.",
    install_app: "యాప్ ఇన్‌స్టాల్ చేయి",
    question_of: "ప్రశ్న",
    of: "లో",
    tap_to_speak: "మాట్లాడటానికి నొక్కు",
    listening: "వింటున్నాను...",
    thinking: "ఆలోచిస్తున్నాను...",
    speaking: "సఖి దీది మాట్లాడుతోంది",
    tap_to_stop: "ఆపడానికి నొక్కు",
    or_type: "లేదా ఇక్కడ రాయి",
    voice_unsupported: "వాయిస్ కోసం Chrome, Edge లేదా Safari వాడు. క్రింద రాసి కూడా అడగవచ్చు.",
    say_again: "మళ్ళీ చెప్పు",
    sos: "సహాయం",
    sos_title: "ఇప్పుడు సహాయం కావాలా?",
    sos_sub: "నువ్వు ఒంటరిగా లేవు. ఈ ఉచిత హెల్ప్‌లైన్‌లకు ఎప్పుడైనా కాల్ చేయవచ్చు.",
    sos_call: "ఇప్పుడు కాల్ చేయి",
    sos_talk_adult: "టీచర్, తల్లిదండ్రులు లేదా నమ్మకమైన పెద్దలతో కూడా మాట్లాడు.",
    childline: "చైల్డ్‌లైన్ (పిల్లల కోసం)",
    women_helpline: "మహిళా హెల్ప్‌లైన్",
    emergency: "అత్యవసరం",
    cyber_helpline: "సైబర్ క్రైమ్",
    send_panic_sms: "నిశ్శబ్ద SMS పంపు",
    panic_sms_body: "నాకు సహాయం కావాలి. ఇది Sakhi Didi యాప్ నుండి అత్యవసర సందేశం.",
    trusted_adult_not_set: "ఇంకా నమ్మకమైన పెద్దలు సెట్ కాలేదు. టీచర్‌ను సెట్టింగ్ తెరవమని అడుగు.",
    settings: "సెట్టింగ్‌లు",
    admin_settings: "స్కూల్ కియోస్క్ సెట్టింగ్‌లు",
    trusted_adult: "నమ్మకమైన పెద్దలు",
    trusted_adult_name: "పేరు (ఉదా. స్కూల్ కౌన్సెలర్)",
    trusted_adult_phone: "ఫోన్ నంబర్ (దేశ కోడ్‌తో)",
    save: "సేవ్",
    saved: "సేవ్ చేయబడింది",
    voice_settings: "సఖి దీది వాయిస్",
    voice_default: "డిఫాల్ట్",
    preview_voice: "వాయిస్ ప్రివ్యూ",
    history: "చరిత్ర",
    my_history: "నా సంభాషణలు",
    no_history: "ఇంకా సఖి దీదితో మాట్లాడలేదు. మైక్ నొక్కి ప్రారంభించు.",
    clear_history: "క్లియర్ చేయి",
    offline_banner: "నువ్వు ఆఫ్‌లైన్‌లో ఉన్నావు. నా సేకరణ నుండి సమాధానం ఇస్తాను.",
    offline_fallback: "ఇప్పుడు నాకు ఖచ్చితంగా తెలియదు. టీచర్‌ను అడుగు, లేదా అత్యవసర సహాయం కోసం 1098కి కాల్ చేయి.",
    suggested_questions: "ఏం అడగాలో తెలియడం లేదా? వీటిలో ఒకటి ఎంచుకో",
    q_period_pain: "నాకు పీరియడ్స్ నొప్పి ఎందుకు?",
    q_feel_sad: "నేను ఎందుకు దుఃఖంగా అనిపిస్తుంది?",
    q_what_is_period: "పీరియడ్ అంటే ఏమిటి?",
    q_stay_safe: "నేను ఎలా సురక్షితంగా ఉండాలి?",
    view_dashboard: "అనలిటిక్స్ చూడు",
    dashboard_title: "కియోస్క్ అనలిటిక్స్",
    dashboard_sub: "ఈ కియోస్క్ నుండి అనామిక వినియోగ డేటా",
    metric_conversations: "సంభాషణలు",
    metric_messages: "మొత్తం సందేశాలు",
    metric_user_msgs: "అడిగిన ప్రశ్నలు",
    metric_quizzes: "కెరీర్ క్విజ్‌లు",
    chart_daily: "రోజువారీ కార్యకలాపాలు (గత 14 రోజులు)",
    chart_lang: "భాషల వారీగా ప్రశ్నలు",
    chart_traits: "కెరీర్ క్విజ్ — టాప్ లక్షణాలు",
    recent_questions: "ఇటీవలి ప్రశ్నలు",
    no_data: "ఇంకా డేటా లేదు. సఖి దీదితో మాట్లాడి ప్రారంభించు.",
    pin_lock: "అడ్మిన్ మాత్రమే",
    pin_create_title: "అడ్మిన్ PIN సృష్టించండి",
    pin_create_sub: "ఈ స్కూల్ కియోస్క్ కోసం 4-అంకెల PIN సెట్ చేయండి. టీచర్లకు మాత్రమే తెలియాలి.",
    pin_enter_title: "అడ్మిన్ PIN నమోదు చేయండి",
    pin_enter_sub: "స్కూల్ సిబ్బంది మాత్రమే సెట్టింగ్‌లు, అనలిటిక్స్ చూడగలరు.",
    pin_confirm: "PIN నిర్ధారించండి",
    pin_mismatch: "PIN సరిపోలడం లేదు. మళ్ళీ ప్రయత్నించండి.",
    pin_wrong: "తప్పు PIN. మళ్ళీ ప్రయత్నించండి.",
    pin_reset_hint: "PIN మర్చిపోయారా?",
    pin_reset_btn: "కియోస్క్ PIN, సెట్టింగ్‌లు రీసెట్ చేయండి",
    pin_reset_confirm: "ఇది PIN, నమ్మకమైన పెద్దలు, ఫోటోను తొలగిస్తుంది. కొనసాగించాలా?",
    unlock: "అన్‌లాక్",
    get_help_now: "ఇప్పుడు సహాయం కావాలి",
    wake_word: "వేక్ వర్డ్ (\"సఖి దీది\" అను)",
    wake_word_hint: "అమ్మాయిలు చేతులు వాడకుండా వేక్ పదాన్ని పలికితే మైక్ మొదలవుతుంది.",
    wake_word_active: "అను",
    wake_phrase_label: "వేక్ పదం",
    wake_phrase_placeholder: "ఉదా. సఖి దీది, అంజలి దీది",
    barge_hint: "మధ్యలో ఎప్పుడైనా మాట్లాడవచ్చు — మాట్లాడటం మొదలుపెట్టు",
    speech_pace: "మాటల వేగం",
    pace_slow: "నిదానం (0.9×)",
    pace_normal: "సాధారణం",
    pace_fast: "వేగం (1.1×)",
  },
};
